var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 88,
    viewBox: "0 0 301 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BAD3F7",
    d: "M279.57 32.29A95.23 95.23 0 0 1 251.5 11c-5.09-5.56-10.79-8.8-17.52-5.38a27.65 27.65 0 0 1-22.87 1l-1.87-.74a80.42 80.42 0 0 0-60.61.14L136 11.2a27.51 27.51 0 0 1-16.16 1.44 27.49 27.49 0 0 0-13.68.67A36.65 36.65 0 0 1 79.27 11C68.08 5.41 60 2.43 46.18 10.1c-12.68 7.07-25.1 13.06-27.72 28.11-2.46 13.91 7.66 24.68-3.2 33.28l-6.17 4.88H288.4c12.77-26.55 2.2-38.63-8.83-44.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M299.48 77.37h-298a1 1 0 0 1 0-2h298a1 1 0 1 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3EA9F9",
    d: "M41.58 31.39h37.21v46.25a.72.72 0 0 1-.72.72H42.3a.72.72 0 0 1-.72-.72V31.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1890FF",
    d: "M41.58 31.39h37.21v9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAC4D4",
    d: "M46.45 21.94a1.72 1.72 0 0 1-1.72-1.85c.127-1.4.531-2.76 1.19-4 1.75-3.37 3.94-3.24 5.5-2.47s8.14 8.28 8.14 8.28l-13.11.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0AABC",
    d: "M47.55 21.94a.86.86 0 0 1-.86-.93 5.1 5.1 0 0 1 .59-2c.87-1.69 2-1.62 2.75-1.24.75.38 4.07 4.14 4.07 4.14l-6.55.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAC4D4",
    d: "M73.92 21.94a1.72 1.72 0 0 0 1.72-1.85 10.56 10.56 0 0 0-1.19-4c-1.74-3.37-3.94-3.24-5.5-2.47s-8.14 8.28-8.14 8.28l13.11.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0AABC",
    d: "M72.82 21.94a.86.86 0 0 0 .86-.93 5.1 5.1 0 0 0-.59-2c-.87-1.69-2-1.62-2.75-1.24-.75.38-4.07 4.14-4.07 4.14l6.55.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.73 18a4 4 0 1 1 0 8h-1.09a4 4 0 1 1 0-8h1.09m0-1h-1.09a5 5 0 0 0 0 10h1.09a5 5 0 0 0 0-10z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.07,
    height: 7.99,
    x: 55.65,
    y: 17.97,
    fill: "#E0AABC",
    rx: 3.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.79,
    height: 5.98,
    x: 56.79,
    y: 18.98,
    fill: "#FAC4D4",
    rx: 2.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3EA9F9",
    d: "M40.75 22h38.87a1 1 0 0 1 1 1v8.42H39.75V23a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6BC3F9",
    d: "M40.75 22h38.87a1 1 0 0 1 1 1v1.76H39.75V23a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAC4D4",
    d: "M55.44 31.39h9.5v46.96h-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0AABC",
    d: "M55.44 36.35l9.49 2.05v-7.01h-9.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.93 79.85h-9.49a.5.5 0 0 1-.5-.5v-47.8a.5.5 0 0 1 .5-.5h9.49a.5.5 0 0 1 .5.5v47.8a.5.5 0 0 1-.5.5zm-9-1h8.49v-46.8h-8.48l-.01 46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAC4D4",
    d: "M54.59 21.97h11.2v9.42h-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.78 31.89H54.59a.5.5 0 0 1-.5-.5V22a.5.5 0 0 1 .5-.5h11.19a.5.5 0 0 1 .5.5v9.42a.5.5 0 0 1-.5.47zm-10.69-1h10.19v-8.42H55.09v8.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE3EC",
    d: "M47.39 16.52a.5.5 0 0 1-.39-.82 7.35 7.35 0 0 1 1.08-1.08.5.5 0 0 1 .7.09.49.49 0 0 1-.08.7c-.34.27-.65.58-.92.92a.51.51 0 0 1-.39.19zM54.1 18.47a.5.5 0 0 1-.37-.16 17.6 17.6 0 0 0-2.12-1.94.51.51 0 0 1-.1-.7.5.5 0 0 1 .7-.1 17.64 17.64 0 0 1 2.26 2.07.49.49 0 0 1 0 .7.5.5 0 0 1-.37.13zM65.55 19.08a.52.52 0 0 1-.35-.14.5.5 0 0 1 0-.71 37.91 37.91 0 0 1 4-3.66.5.5 0 0 1 .67.22.5.5 0 0 1-.22.67 39.61 39.61 0 0 0-3.78 3.48.54.54 0 0 1-.32.14zM64 24h-7.62a.5.5 0 1 1 0-1H64a.5.5 0 1 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.62 22a1 1 0 0 1 1 1v8.38H39.75V23a1 1 0 0 1 1-1h38.87m0-1H40.75a2 2 0 0 0-2 2v8.38a1 1 0 0 0 1 1h40.87a1 1 0 0 0 1-1V23a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M70.73 13.21c1.23 0 2.57.7 3.72 2.92a10.56 10.56 0 0 1 1.19 4 1.72 1.72 0 0 1-1.72 1.85h5.86c.46 0 .835.37.84.83v8.59h-1.83v46.12a.83.83 0 0 1-.83.83H42.41a.83.83 0 0 1-.83-.83V31.39h-1.83V22.8a.84.84 0 0 1 .84-.83h5.86a1.72 1.72 0 0 1-1.72-1.85c.127-1.4.531-2.76 1.19-4 1.15-2.22 2.49-2.92 3.72-2.92a4.08 4.08 0 0 1 1.78.45c.9.46 3.5 3.18 5.53 5.38A3.94 3.94 0 0 1 59.64 18h1.09a3.94 3.94 0 0 1 2.69 1c2-2.2 4.63-4.92 5.53-5.38a4.11 4.11 0 0 1 1.78-.45m0-2a5.83 5.83 0 0 0-2.67.67c-.42.21-1.26.63-5 4.58a6 6 0 0 0-2.33-.42h-1.09a6 6 0 0 0-2.36.49c-3.71-3.95-4.55-4.37-5-4.58a5.83 5.83 0 0 0-2.67-.67c-1.56 0-3.78.69-5.5 4a12.45 12.45 0 0 0-1.4 4.72h-2.13a2.83 2.83 0 0 0-2.83 2.83v8.59a2 2 0 0 0 1.83 2v44.14a2.83 2.83 0 0 0 2.83 2.83H78a2.83 2.83 0 0 0 2.83-2.83V33.38a2 2 0 0 0 1.83-2V22.8a2.84 2.84 0 0 0-2.88-2.8h-2.14a12.45 12.45 0 0 0-1.4-4.72c-1.72-3.31-3.94-4-5.5-4l-.01-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A2CBB",
    d: "M218.8 44.89H265v32.46a1 1 0 0 1-1 1h-44.2a1 1 0 0 1-1-1V44.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8114A2",
    d: "M218.8 44.89h46.18v11.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M224.85 33.17a2.14 2.14 0 0 1-2.14-2.3 12.93 12.93 0 0 1 1.48-4.87c2.17-4.19 4.89-4 6.82-3.06 1.93.94 10.11 10.27 10.11 10.27l-16.27-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M226.21 33.17a1.07 1.07 0 0 1-1.07-1.17 6.42 6.42 0 0 1 .74-2.46c1.08-2.09 2.45-2 3.41-1.53s5.05 5.14 5.05 5.14l-8.13.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M258.93 33.17a2.14 2.14 0 0 0 2.14-2.3 12.93 12.93 0 0 0-1.48-4.87c-2.16-4.19-4.89-4-6.82-3.06-1.93.94-10.11 10.27-10.11 10.27l16.27-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M257.57 33.17a1.07 1.07 0 0 0 1.07-1.17 6.42 6.42 0 0 0-.74-2.46c-1.08-2.09-2.44-2-3.41-1.53-.97.47-5.05 5.14-5.05 5.14l8.13.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M242.56 28.24a5 5 0 0 1 0 9.92h-1.34a5 5 0 0 1 0-9.92h1.34m0-1h-1.34a6 6 0 0 0 0 11.92h1.34a6 6 0 0 0 0-11.92z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.91,
    x: 236.26,
    y: 28.24,
    fill: "#DCA93B",
    rx: 4.955
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.42,
    height: 7.42,
    x: 237.68,
    y: 29.49,
    fill: "#F6C354",
    rx: 3.71
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A2CBB",
    d: "M217.54 33.2h48.71a1 1 0 0 1 1 1v10.7h-50.71V34.2a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B559D8",
    d: "M217.54 33.2h48.71a1 1 0 0 1 1 1v2.43h-50.71V34.2a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M236 44.89h11.79v33.46H236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M236 51.05l11.79 2.54v-8.7H236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M234.94 33.2h13.9v11.7h-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M247.79 79.89H236a.5.5 0 0 1-.5-.5v-34.5a.5.5 0 0 1 .5-.5h11.79a.51.51 0 0 1 .5.5v34.5a.51.51 0 0 1-.5.5zm-11.29-1h10.79v-33.5H236.5v33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M248.84 45.39h-13.9a.5.5 0 0 1-.5-.5V33.2a.5.5 0 0 1 .5-.5h13.9a.5.5 0 0 1 .5.5v11.69a.5.5 0 0 1-.5.5zm-13.4-1h12.9V33.7h-12.9v10.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DB98",
    d: "M226 26.31a.54.54 0 0 1-.31-.1.52.52 0 0 1-.08-.71 8.3 8.3 0 0 1 1.39-1.32.5.5 0 0 1 .7.08.52.52 0 0 1-.08.71 6.37 6.37 0 0 0-1.16 1.16.52.52 0 0 1-.46.18zM234.34 28.74a.5.5 0 0 1-.37-.16 21.29 21.29 0 0 0-2.65-2.42.5.5 0 0 1-.09-.7.49.49 0 0 1 .7-.1 23.81 23.81 0 0 1 2.78 2.54.5.5 0 0 1-.37.84zM248.55 29.5a.47.47 0 0 1-.35-.15.48.48 0 0 1 0-.7 46.37 46.37 0 0 1 5-4.52.5.5 0 0 1 .45.89 51.25 51.25 0 0 0-4.73 4.33.47.47 0 0 1-.37.15zM246.62 35.64h-9.45a.5.5 0 0 1 0-1h9.45a.51.51 0 0 1 .5.5.5.5 0 0 1-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M255 22.33c1.52 0 3.19.87 4.61 3.63a12.93 12.93 0 0 1 1.48 4.91 2.14 2.14 0 0 1-2.14 2.3h7.28a1 1 0 0 1 1 1v10.72H265v32.43a1 1 0 0 1-1 1h-44.16a1 1 0 0 1-1-1V44.89h-2.26V34.23a1 1 0 0 1 1-1h7.28a2.14 2.14 0 0 1-2.14-2.3 12.93 12.93 0 0 1 1.47-4.93c1.42-2.76 3.09-3.63 4.62-3.63a5 5 0 0 1 2.2.57c1.12.56 4.35 3.94 6.86 6.67a4.93 4.93 0 0 1 3.35-1.33h1.34a4.93 4.93 0 0 1 3.35 1.33c2.51-2.73 5.74-6.11 6.86-6.67a5 5 0 0 1 2.21-.57m0-2a6.84 6.84 0 0 0-3.1.78c-.47.23-1.52.76-6.28 5.84a6.92 6.92 0 0 0-3-.71h-1.34a6.92 6.92 0 0 0-3 .71c-4.76-5.08-5.81-5.61-6.28-5.84a6.83 6.83 0 0 0-3.09-.78c-1.81 0-4.38.82-6.4 4.71a15 15 0 0 0-1.69 5.67 3.73 3.73 0 0 0 0 .47h-3.15a3 3 0 0 0-3 3v10.67a2 2 0 0 0 2 2h.26v30.43a3 3 0 0 0 3 3H264a3 3 0 0 0 3-3V46.89h.27a2 2 0 0 0 2-2V34.23a3 3 0 0 0-3-3h-3.14a2.48 2.48 0 0 0 0-.47 15 15 0 0 0-1.76-5.76c-2-3.89-4.59-4.71-6.39-4.71v.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M266.25 33.2a1 1 0 0 1 1 1v10.69h-50.71V34.2a1 1 0 0 1 1-1h48.71m0-1h-48.71a2 2 0 0 0-2 2v10.69a1 1 0 0 0 1 1h50.71a1 1 0 0 0 1-1V34.2a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82C45B",
    d: "M157.14 61.55h79.49v15.8a1 1 0 0 1-1 1h-77.49a1 1 0 0 1-1-1v-15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75B052",
    d: "M157.14 61.55h79.49v11.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    d: "M179.85 49.82a2.13 2.13 0 0 1-2.14-2.29 12.89 12.89 0 0 1 1.47-4.91c2.17-4.19 4.9-4 6.82-3.07 1.92.93 10.11 10.27 10.11 10.27h-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2470D",
    d: "M181.21 49.82a1.06 1.06 0 0 1-1.07-1.14 6.56 6.56 0 0 1 .73-2.46c1.09-2.09 2.45-2 3.41-1.53s5.06 5.13 5.06 5.13h-8.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    d: "M213.93 49.82a2.14 2.14 0 0 0 2.14-2.29 13.12 13.12 0 0 0-1.48-4.91c-2.17-4.19-4.89-4-6.82-3.07-1.93.93-10.11 10.27-10.11 10.27h16.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2470D",
    d: "M212.57 49.82a1.06 1.06 0 0 0 1.07-1.14 6.61 6.61 0 0 0-.74-2.46c-1.08-2.09-2.45-2-3.41-1.53s-5.06 5.13-5.06 5.13h8.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M197.56 44.9a5 5 0 1 1 0 9.91h-1.34a5 5 0 1 1 0-9.91h1.34m0-1h-1.34a6 6 0 1 0 0 11.91h1.34a6 6 0 1 0 0-11.91z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.91,
    x: 191.26,
    y: 44.9,
    fill: "#C2470D",
    rx: 4.955
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.42,
    height: 7.42,
    x: 192.68,
    y: 46.15,
    fill: "#DC6127",
    rx: 3.71
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82C45B",
    d: "M155.87 49.86h82a1 1 0 0 1 1 1v10.7h-84v-10.7a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D87C",
    d: "M155.87 49.86h82a1 1 0 0 1 1 1v2.43h-84v-2.43a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    d: "M190.99 61.55h11.79v16.8h-11.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2470D",
    d: "M190.99 67.71l11.79 2.54v-8.7h-11.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    d: "M189.94 49.86h13.9v11.7h-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M202.78 79.89H191a.51.51 0 0 1-.5-.5V61.55a.5.5 0 0 1 .5-.5h11.79a.5.5 0 0 1 .5.5v17.84a.5.5 0 0 1-.51.5zm-11.29-1h10.79V62.05h-10.79v16.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M203.83 62.05h-13.89a.5.5 0 0 1-.5-.5V49.86a.5.5 0 0 1 .5-.5h13.89a.5.5 0 0 1 .5.5v11.69a.5.5 0 0 1-.5.5zm-13.39-1h12.89V50.36h-12.89v10.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF955A",
    d: "M181 43a.45.45 0 0 1-.31-.11.49.49 0 0 1-.08-.7 7.85 7.85 0 0 1 1.32-1.32.5.5 0 1 1 .62.78 8 8 0 0 0-1.16 1.16.48.48 0 0 1-.39.19zM189.34 45.4a.5.5 0 0 1-.37-.17 22.2 22.2 0 0 0-2.65-2.42.5.5 0 1 1 .6-.79 22.51 22.51 0 0 1 2.79 2.54.5.5 0 0 1-.37.84zM203.55 46.16a.51.51 0 0 1-.36-.15.51.51 0 0 1 0-.71 49.76 49.76 0 0 1 5-4.52.5.5 0 0 1 .44.9A48.78 48.78 0 0 0 203.9 46a.5.5 0 0 1-.35.16zM201.61 52.3h-9.45a.5.5 0 0 1 0-1h9.45a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M210 39c1.52 0 3.19.87 4.62 3.63a13.12 13.12 0 0 1 1.48 4.91 2.14 2.14 0 0 1-2.14 2.29h23.94a1 1 0 0 1 1 1v10.72h-2.27v15.77a1 1 0 0 1-1 1h-77.45a1 1 0 0 1-1-1V61.55h-2.27V50.89a1 1 0 0 1 1-1h23.94a2.13 2.13 0 0 1-2.14-2.29 12.89 12.89 0 0 1 1.47-4.91c1.43-2.76 3.1-3.63 4.62-3.63a4.91 4.91 0 0 1 2.2.56c1.12.56 4.36 3.94 6.87 6.68a4.89 4.89 0 0 1 3.35-1.33h1.34a4.89 4.89 0 0 1 3.34 1.33c2.52-2.74 5.75-6.12 6.87-6.68A5 5 0 0 1 210 39m0-2a6.8 6.8 0 0 0-3.09.78c-.47.23-1.52.75-6.28 5.84a6.92 6.92 0 0 0-3-.71h-1.34a7 7 0 0 0-3.05.71c-4.75-5.09-5.8-5.61-6.27-5.84a6.84 6.84 0 0 0-3.1-.78c-1.8 0-4.38.82-6.39 4.71a15.13 15.13 0 0 0-1.7 5.67v.46h-19.79a3 3 0 0 0-3 3v10.71a2 2 0 0 0 2 2h.27v13.77a3 3 0 0 0 3 3h77.34a3 3 0 0 0 3-3V63.55h.27a2 2 0 0 0 2-2V50.89a3 3 0 0 0-3-3h-19.8a3.53 3.53 0 0 0 0-.46 14.93 14.93 0 0 0-1.69-5.67c-2-3.89-4.59-4.71-6.4-4.71L210 37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M237.9 49.86a1 1 0 0 1 1 1v10.69h-84V50.86a1 1 0 0 1 1-1h82m0-1h-82a2 2 0 0 0-2 2v10.69a1 1 0 0 0 1 1h84a1 1 0 0 0 1-1V50.86a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D84F10",
    d: "M65.47 51.55H145v25.8a1 1 0 0 1-1 1H66.47a1 1 0 0 1-1-1v-25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2470D",
    d: "M65.47 51.55h79.49v21.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADBBD0",
    d: "M88.18 39.82A2.13 2.13 0 0 1 86 37.53a12.93 12.93 0 0 1 1.48-4.91c2.16-4.19 4.89-4 6.82-3.07 1.93.93 10.11 10.27 10.11 10.27H88.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92A1B7",
    d: "M89.54 39.82a1.06 1.06 0 0 1-1.07-1.14 6.42 6.42 0 0 1 .74-2.46c1.08-2.09 2.44-2 3.41-1.53.97.47 5 5.13 5 5.13h-8.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADBBD0",
    d: "M122.26 39.82a2.14 2.14 0 0 0 2.14-2.29 12.93 12.93 0 0 0-1.48-4.91c-2.17-4.19-4.89-4-6.82-3.07-1.93.93-10.1 10.27-10.1 10.27h16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92A1B7",
    d: "M120.9 39.82a1.06 1.06 0 0 0 1.1-1.14 6.42 6.42 0 0 0-.74-2.46c-1.08-2.09-2.45-2-3.41-1.53s-5 5.13-5 5.13h8.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M105.89 34.9a5 5 0 1 1 0 9.91h-1.34a5 5 0 1 1 0-9.91h1.34m0-1h-1.34a6 6 0 1 0 0 11.91h1.34a6 6 0 1 0 0-11.91z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.26,
    height: 9.91,
    x: 99.59,
    y: 34.9,
    fill: "#92A1B7",
    rx: 4.955
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.42,
    height: 7.42,
    x: 101.01,
    y: 36.15,
    fill: "#ADBBD0",
    rx: 3.71
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D84F10",
    d: "M64.21 39.86h82a1 1 0 0 1 1 1v10.7h-84v-10.7a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    d: "M64.21 39.86h82a1 1 0 0 1 1 1v2.43h-84v-2.43a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADBBD0",
    d: "M99.33 51.55h11.79v26.8H99.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92A1B7",
    d: "M99.33 61.71l11.78 3.54v-13.7H99.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADBBD0",
    d: "M98.27 39.86h13.9v11.7h-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M111.11 79.89H99.33a.5.5 0 0 1-.5-.5V51.55a.5.5 0 0 1 .5-.5h11.78a.5.5 0 0 1 .5.5v27.84a.5.5 0 0 1-.5.5zm-11.28-1h10.78V52.05H99.83v26.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M112.17 52.05h-13.9a.5.5 0 0 1-.5-.5V39.86a.5.5 0 0 1 .5-.5h13.9a.5.5 0 0 1 .5.5v11.69a.5.5 0 0 1-.5.5zm-13.4-1h12.9V40.36h-12.9v10.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2EBFF",
    d: "M89.34 33a.45.45 0 0 1-.31-.11.49.49 0 0 1-.08-.7 8.24 8.24 0 0 1 1.32-1.32.51.51 0 0 1 .71.08.5.5 0 0 1-.09.7 8 8 0 0 0-1.16 1.16.48.48 0 0 1-.39.19zM97.67 35.4a.51.51 0 0 1-.37-.17 22.2 22.2 0 0 0-2.65-2.42.51.51 0 0 1-.1-.7.5.5 0 0 1 .7-.09A22.51 22.51 0 0 1 98 34.56a.5.5 0 0 1-.37.84h.04zM111.88 36.16a.51.51 0 0 1-.36-.15.51.51 0 0 1 0-.71 49.76 49.76 0 0 1 5-4.52.5.5 0 0 1 .67.23.51.51 0 0 1-.22.67 47.46 47.46 0 0 0-4.74 4.32.49.49 0 0 1-.35.16zM109.94 42.3h-9.45a.5.5 0 0 1 0-1h9.45a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M118.3 29c1.53 0 3.2.87 4.62 3.63a12.93 12.93 0 0 1 1.48 4.91 2.14 2.14 0 0 1-2.14 2.29h23.94a1 1 0 0 1 1 1v10.72H145v25.77a1 1 0 0 1-1 1H66.51a1 1 0 0 1-1-1V51.55h-2.3V40.89a1 1 0 0 1 1-1h23.94A2.13 2.13 0 0 1 86 37.53a12.93 12.93 0 0 1 1.48-4.91c1.42-2.76 3.09-3.63 4.61-3.63a5 5 0 0 1 2.21.56c1.12.56 4.35 3.94 6.86 6.68a4.93 4.93 0 0 1 3.35-1.33h1.34a4.93 4.93 0 0 1 3.35 1.33c2.51-2.74 5.74-6.12 6.86-6.68a5 5 0 0 1 2.2-.56m0-2a6.83 6.83 0 0 0-3.09.78c-.47.23-1.52.75-6.28 5.84a6.92 6.92 0 0 0-3-.71h-1.34a6.92 6.92 0 0 0-3 .71c-4.76-5.09-5.81-5.61-6.28-5.84a6.84 6.84 0 0 0-3.1-.78c-1.8 0-4.38.82-6.39 4.71a14.94 14.94 0 0 0-1.69 5.66 3.77 3.77 0 0 0 0 .47H64.3a3 3 0 0 0-3 3v10.72a2 2 0 0 0 2 2h.26v23.77a3 3 0 0 0 3 3h77.42a3 3 0 0 0 3-3V53.55h.27a2 2 0 0 0 2-2V40.89a3 3 0 0 0-3-3h-19.8a3.53 3.53 0 0 0 0-.46 14.93 14.93 0 0 0-1.69-5.67c-2-3.89-4.59-4.71-6.4-4.71l-.1-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M146.23 39.86a1 1 0 0 1 1 1v10.69h-84V40.86a1 1 0 0 1 1-1h82m0-1h-82a2 2 0 0 0-2 2v10.69a1 1 0 0 0 1 1h84a1 1 0 0 0 1-1V40.86a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B78625",
    d: "M162.49 61a25.17 25.17 0 0 1-5.75 5.21 13.15 13.15 0 0 1-12.48 0 24.61 24.61 0 0 1-5.48-4.9c-1.1-1.28-6.62-10.39-7.47-17.19-1.42-11.38-1.61-26.39-1.61-26.39v-3.34a5 5 0 0 1 5-5h31.62a5 5 0 0 1 5 5v3.33s-.18 15-1.6 26.34c-.87 6.82-6.21 15.71-7.23 16.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M164 75.56h-7.28V66.2a13.15 13.15 0 0 1-12.48 0v9.36H137a7.28 7.28 0 0 0-7.28 7.28v1.56a1.56 1.56 0 0 0 1.54 1.6h38.48a1.56 1.56 0 0 0 1.56-1.56v-1.6a7.28 7.28 0 0 0-7.3-7.28zM184.82 17.72H171.3v8.32h8.36v10.82a9.43 9.43 0 0 1-5.81 8.71l-2.55 1c-.71.28-1.66.63-1.66.63l-4 9.39s1.27-.17 1.89-.28a29.83 29.83 0 0 0 12.41-5.15c5.11-3.67 8.05-8.45 8.05-13.09V20.84a3.12 3.12 0 0 0-3.17-3.12zM131.39 47.25s-.8-.29-1.38-.52c-.8-.32-1.8-.73-2.82-1.16a9.41 9.41 0 0 1-5.81-8.7V26h8.35v-8.32h-13.55a3.12 3.12 0 0 0-3.12 3.12v17.32c0 4.64 2.93 9.42 8.05 13.09A30.23 30.23 0 0 0 134 56.44c.48.08 1.43.2 1.43.2l-4.04-9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M113.06 35.1v3c0 4.64 2.93 9.42 8.05 13.09A30.23 30.23 0 0 0 134 56.44c.48.08 1.43.2 1.43.2l-2-4.64c-15.94-2-20.37-16.9-20.37-16.9zM165.59 56.64s1.27-.17 1.89-.28a29.83 29.83 0 0 0 12.41-5.15c5.11-3.67 8.05-8.45 8.05-13.09V35l-.11.1s-4.4 14.82-20.25 16.9l-1.99 4.64zM129.7 80.84h41.6v2h-41.6zM144.26 66.2h12.48v9.36h-12.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DB98",
    d: "M129.7 17.72h-13.52c-1.73 0-3.12 1-3.12 2.28v2.51a5.38 5.38 0 0 1 4.49-2.25h12.15v-2.54zM184.82 17.72h-13.06v2.54h11.07a8.42 8.42 0 0 1 3.88.87c.68.36 1.23.83 1.23 1.38V20c0-1.26-1.39-2.28-3.12-2.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B78625",
    d: "M144.26 66.2A5.77 5.77 0 0 0 150 72h1a5.77 5.77 0 0 0 5.77-5.77h-12.51v-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.83 20.76h-11.07a.5.5 0 0 1 0-1h11.07a.5.5 0 0 1 0 1zM128.08 20.76h-10.53a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.5h10.53a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M168 18.05h-38.3v.67s.19 14 1.61 25.39c.85 6.8 6.37 15.91 7.47 17.19a24.61 24.61 0 0 0 5.48 4.9 13.15 13.15 0 0 0 12.48 0 25.17 25.17 0 0 0 5.75-5.2c1-1.22 6.36-10.11 7.21-16.93 1.42-11.37 1.6-25.34 1.6-25.34V16a3.78 3.78 0 0 1-3.3 2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M139.55 62.16c.52.38.83.56.83.56a13.15 13.15 0 0 0 12.48 0 25.09 25.09 0 0 0 5.75-5.22c1-1.21 6.36-10.1 7.21-16.92 1-8.36 1.42-17.66 1.54-22.53h-33.49a5.26 5.26 0 0 1-3.66-1.49l-.51-.51v2.67s.19 14 1.61 25.39c.85 6.8 6.37 15.91 7.47 17.19l.77.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M173.4 5.79l-2 4.61a2.31 2.31 0 1 1 0 4.61h-.1v2.71h13.52a3.12 3.12 0 0 1 3.12 3.12v17.28c0 4.64-2.94 9.42-8.05 13.09a30.38 30.38 0 0 1-14.3 5.43 28.7 28.7 0 0 1-8.85 9.56v9.36H164a7.28 7.28 0 0 1 7.28 7.28v1.56a1.56 1.56 0 0 1-1.54 1.6h-38.48a1.56 1.56 0 0 1-1.56-1.56v-1.6a7.28 7.28 0 0 1 7.3-7.28h7.28V66.2a28.7 28.7 0 0 1-8.85-9.56 30.46 30.46 0 0 1-14.3-5.43c-5.12-3.67-8.05-8.45-8.05-13.09V20.84a3.12 3.12 0 0 1 3.12-3.12h13.5V15h-.1a2.31 2.31 0 1 1 0-4.61l-2-4.61h45.8m-3.8 41.46c.76-.26 2.44-.94 4.21-1.68a9.43 9.43 0 0 0 5.81-8.71V26h-8.36c-.13 4.24-.75 18-1.66 21.21m-38.21 0c-.91-3.25-1.53-17-1.66-21.21h-8.35v10.87a9.41 9.41 0 0 0 5.81 8.7c1.77.74 3.44 1.42 4.2 1.68m42-43.46H127.6a2 2 0 0 0-1.84 2.8l1.18 2.73a4.31 4.31 0 0 0-1.65 3.39 4.25 4.25 0 0 0 1.24 3h-10.35a5.13 5.13 0 0 0-5.12 5.12v17.29c0 5.3 3.24 10.67 8.88 14.72a32.39 32.39 0 0 0 14.27 5.66 32.55 32.55 0 0 0 8 8.77v6.29H137a9.29 9.29 0 0 0-9.28 9.28v1.56a3.57 3.57 0 0 0 3.54 3.6h38.48a3.57 3.57 0 0 0 3.56-3.56v-1.6a9.29 9.29 0 0 0-9.3-9.28h-5.28v-6.29a32.55 32.55 0 0 0 8-8.77 32.15 32.15 0 0 0 14.27-5.67c5.64-4 8.88-9.42 8.88-14.71V20.84a5.13 5.13 0 0 0-5.12-5.12h-10.28a4.25 4.25 0 0 0 1.24-3 4.31 4.31 0 0 0-1.65-3.39l1.18-2.73a2 2 0 0 0-1.84-2.8l-.01-.01zm-.2 24.21h4.43v8.82a7.42 7.42 0 0 1-4.62 6.91l-.91.37c.56-4.91.92-12.52 1.06-16.06l.04-.04zm-49.81 0h4.42c.14 3.54.5 11.14 1.06 16.06l-.9-.37a7.42 7.42 0 0 1-4.58-6.86V28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DB98",
    d: "M134.12 37.12a1 1 0 0 1-1-.93c0-.39-.28-2.74-.52-5-.37-3.43-.62-5.7-.64-6.15a1 1 0 0 1 1.665-.79 1 1 0 0 1 .335.69c0 .42.34 3.41.63 6.05.29 2.64.5 4.67.53 5.09a1 1 0 0 1-.93 1.07l-.07-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M171.3 14.39v3.33s-.18 15-1.6 26.34c-.85 6.82-6.19 15.71-7.21 16.93a25.17 25.17 0 0 1-5.75 5.21 13.11 13.11 0 0 1-12.48 0 24.61 24.61 0 0 1-5.48-4.9c-1.1-1.28-6.62-10.39-7.47-17.19-1.42-11.38-1.61-26.39-1.61-26.39v-3.33h41.6m0-2h-41.6a2 2 0 0 0-2 2v3.33c0 .18.21 15.28 1.63 26.64.91 7.3 6.58 16.67 7.93 18.25a26.67 26.67 0 0 0 6 5.32h.06a15.11 15.11 0 0 0 14.38 0h.07a26.71 26.71 0 0 0 6.23-5.66c1.3-1.55 6.77-10.8 7.67-18C173.1 33 173.3 17.9 173.3 17.75v-3.36a2 2 0 0 0-2-2zM158 75.56h-14.9a1 1 0 1 1 0-2H158a1 1 0 1 1 0 2zM155.79 81.34H129.7a.5.5 0 0 1 0-1h26.09a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M171.3 83.34h-27a.5.5 0 0 1 0-1h26.5v-1h-6.25a.5.5 0 0 1 0-1h6.75a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zM135 83.34h-5.3a.5.5 0 0 1 0-1h5.3a.51.51 0 0 1 .5.5.5.5 0 0 1-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M155.79 81.34H129.7a.5.5 0 0 1 0-1h26.09a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DB98",
    d: "M141.93 79.32h-7.09a1 1 0 1 1 0-2h7.09a1 1 0 1 1 0 2z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.42,
    height: 4.61,
    x: 127.29,
    y: 10.4,
    fill: "#DCA93B",
    rx: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    d: "M171.4 10.4h-41.8l-2-4.61h45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DB98",
    d: "M140.05 13.71h-9.33a1 1 0 1 1 0-2h9.33a1 1 0 1 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M171.4 16h-41.8a.5.5 0 0 1 0-1h41.8a.5.5 0 0 1 0 1zM171.82 10.4h-42.64a.5.5 0 0 1 0-1h42.64a.5.5 0 0 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DB98",
    d: "M128.36 7.56h44.28l.76-1.77h-45.8zM146.45 25.13c1 4.29 4.12 6.62 5.61 6.82l-1.45-2.59h5.68a4.1 4.1 0 0 1 2.92 1.22 3.88 3.88 0 0 1 1.26 2.77 6.47 6.47 0 0 0-1.53-1.47 4.05 4.05 0 0 0-2.34-.73 6.86 6.86 0 0 0-3 .83l-.4.21c-.43.24-.89.52-1.32.82-.06 0-1.33-.82-1.93-1.09a6.06 6.06 0 0 0-2.46-.58A4.5 4.5 0 0 0 145 32a5.74 5.74 0 0 0-2.82 5.2 9.54 9.54 0 0 0 3 6.65 8.81 8.81 0 0 0 6.61 3h.32a9.17 9.17 0 0 0 6.71-3.23 10 10 0 0 0 1.6-2.22v2.68a3.92 3.92 0 0 1-1.26 3 4 4 0 0 1-2.91 1.25H144.7a4 4 0 0 1-2.91-1.25 4.06 4.06 0 0 1-1.26-3V33.59a4.06 4.06 0 0 1 1.26-3 4.1 4.1 0 0 1 2.92-1.22h2s-1.23-2.31-.3-4.23m0-2a2 2 0 0 0-1.8 1.13 5.93 5.93 0 0 0-.52 3.13 6.24 6.24 0 0 0-5.6 6.23v10.54a6.3 6.3 0 0 0 6.17 6.23h11.6a6.06 6.06 0 0 0 4.32-1.83 5.9 5.9 0 0 0 1.85-4.43v-2.65a2 2 0 0 0-1.43-1.94 2 2 0 0 0-2.25 1 9.11 9.11 0 0 1-1.29 1.8 7.14 7.14 0 0 1-5.32 2.56h-.22a6.83 6.83 0 0 1-5.15-2.41 7.63 7.63 0 0 1-2.47-5.29 3.76 3.76 0 0 1 1.87-3.5 2.48 2.48 0 0 1 1.37-.4 4.08 4.08 0 0 1 1.64.4c.36.17 1.24.7 1.53.87l.33.19a2 2 0 0 0 .89.21 2 2 0 0 0 1.15-.37c.31-.22.68-.44 1.15-.71l.33-.17a5 5 0 0 1 2.12-.61 1.94 1.94 0 0 1 1.19.38c.411.27.773.608 1.07 1a2 2 0 0 0 1.61.81 1.92 1.92 0 0 0 .66-.12 2 2 0 0 0 1.34-1.94 6 6 0 0 0-1.87-4.15 6.13 6.13 0 0 0-4.31-1.78h-5.68a2 2 0 0 0-1 .25 8.38 8.38 0 0 1-1.23-2.91 2 2 0 0 0-1.72-1.55h-.24l-.09.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M146.45 25.13c1 4.29 4.12 6.62 5.61 6.82l-1.45-2.59h5.68a4.1 4.1 0 0 1 2.92 1.22 3.88 3.88 0 0 1 1.26 2.77 6.47 6.47 0 0 0-1.53-1.47 4.05 4.05 0 0 0-2.34-.73 6.86 6.86 0 0 0-3 .83l-.4.21c-.43.24-.89.52-1.32.82-.06 0-1.33-.82-1.93-1.09a6.06 6.06 0 0 0-2.46-.58A4.5 4.5 0 0 0 145 32a5.74 5.74 0 0 0-2.82 5.2 9.54 9.54 0 0 0 3 6.65 8.81 8.81 0 0 0 6.61 3h.32a9.17 9.17 0 0 0 6.71-3.23 10 10 0 0 0 1.6-2.22v2.68a3.92 3.92 0 0 1-1.26 3 4 4 0 0 1-2.91 1.25H144.7a4 4 0 0 1-2.91-1.25 4.06 4.06 0 0 1-1.26-3V33.59a4.06 4.06 0 0 1 1.26-3 4.1 4.1 0 0 1 2.92-1.22h2s-1.23-2.31-.3-4.23m0-.75a.75.75 0 0 0-.67.43 5.24 5.24 0 0 0-.13 3.8h-.94a5 5 0 0 0-4.93 5v10.55a5 5 0 0 0 4.92 5h11.6a4.78 4.78 0 0 0 3.46-1.49 4.61 4.61 0 0 0 1.46-3.51v-2.68a.77.77 0 0 0-.57-.73h-.18a.75.75 0 0 0-.66.4 9.7 9.7 0 0 1-1.48 2.06 8.48 8.48 0 0 1-6.21 3h-.28a8.12 8.12 0 0 1-6.07-2.81 8.78 8.78 0 0 1-2.8-6.14 5 5 0 0 1 2.46-4.57 3.84 3.84 0 0 1 2-.58 5.37 5.37 0 0 1 2.15.51c.43.2 1.29.72 1.66.94l.25.14a.73.73 0 0 0 .76-.06c.35-.24.75-.49 1.26-.78l.38-.2a6.11 6.11 0 0 1 2.68-.74 3.26 3.26 0 0 1 1.91.6c.52.353.98.789 1.36 1.29a.74.74 0 0 0 .6.31.79.79 0 0 0 .25-.05.75.75 0 0 0 .5-.73 4.71 4.71 0 0 0-1.5-3.29 4.83 4.83 0 0 0-3.43-1.42h-5.68a.75.75 0 0 0-.66 1.12l.2.36a9.4 9.4 0 0 1-3-5.12.76.76 0 0 0-.65-.58l-.02-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M152.16 46.94a8.81 8.81 0 0 1-6.93-3 9.54 9.54 0 0 1-3-6.65A5.74 5.74 0 0 1 145 32a4.9 4.9 0 0 1 4.88-.12c.6.27 1.87 1.06 1.93 1.09.43-.3.89-.58 1.32-.82l.4-.21c2.15-1.07 3.93-1.1 5.36-.1a6.33 6.33 0 0 1 1.54 1.47 3.88 3.88 0 0 0-1.26-2.77 4.12 4.12 0 0 0-3-1.22h-5.6l1.49 2.68c-1.49-.2-4.66-2.53-5.61-6.82-.93 1.92.3 4.23.3 4.23h-1.95a4.13 4.13 0 0 0-3 1.22 4.06 4.06 0 0 0-1.26 3v10.54a4.06 4.06 0 0 0 1.26 3 4 4 0 0 0 3 1.24h11.41a4 4 0 0 0 3-1.24 3.92 3.92 0 0 0 1.26-3v-2.68a10 10 0 0 1-1.6 2.22 9.17 9.17 0 0 1-6.71 3.23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllRewards);
export default __webpack_public_path__ + "static/media/ill_rewards.528af1208ae87ea44b31217eb85ec3c8.svg";
export { ForwardRef as ReactComponent };